import { useSnapshot } from 'valtio';
import eventState from 'modules/events/states/events.states';

const CX_SURVEY_REMINDER_NAME_MATCH = 'cx survey';

export const isCxSurveyReminder = (reminderName: string): boolean => reminderName.toLowerCase().includes(CX_SURVEY_REMINDER_NAME_MATCH);

export const useCxSurveyReminderSync = () => {
  const snap = useSnapshot(eventState);
  const eventId = snap.createEvent._id;
  const isEditFlow = Boolean(eventId);
  const { cxSurveyReminderEnabled } = snap.createEvent;

  const setCxSurveyReminderEnabled = (enabled: boolean) => {
    eventState.createEvent.cxSurveyReminderEnabled = enabled;
  };

  return {
    isEditFlow,
    eventId,
    cxSurveyReminderEnabled,
    setCxSurveyReminderEnabled,
  };
};
